import moment from "moment";

export default function PassengerDetails({ passenger, index }) {
  const { FirstName, LastName, Email, DOB, Gender, Nationality, PaxDoc } =
    passenger;
  const { ExpDateText, Number, DocType, IssueCountry, NationalityCountry } =
    PaxDoc || {};

  return (
    <>
      <tr className="bg-slate-200">
        <td colSpan={4}>
          <h2 className="font-bold text-lg py-1">
            Passenger {index} Details
          </h2>
        </td>
      </tr>
      <tr>
        <th>First Name</th>
        <td>{FirstName}</td>

        <th>Last Name</th>
        <td>{LastName}</td>
      </tr>
      <tr>
        <th>Email</th>
        <td>{Email}</td>

        <th>Date of Birth</th>
        <td>{DOB ? moment(DOB).format("ll") : "-"}</td>
      </tr>
      <tr>
        <th>Gender</th>
        <td>{Gender}</td>

        <th>Nationality</th>
        <td>{Nationality}</td>
      </tr>
      <tr>
        <th>Document Type</th>
        <td>{DocType || "-"}</td>

        <th>Document Number</th>
        <td>{Number || "-"}</td>
      </tr>
      <tr>
        <th>Document Expiry Date</th>
        <td>
          {ExpDateText ? moment(ExpDateText).format("ll") : "-"}
        </td>

        <th>Issue Country</th>
        <td>{IssueCountry || "-"}</td>
      </tr>
      <tr>
        <th>Nationality Country</th>
        <td>{NationalityCountry || "-"}</td>
      </tr>
      <tr>
        <td colSpan={4} className="min-h-5">
          <span className="invisible">sr-only</span>
        </td>
      </tr>
    </>
  );
}
